import enums from '@/utils/enums';
import { NOTIFICATIONS, ROLES, SOLICITATE_TYPE } from '../../utils/constants';
import requestService from '@/services/request';
import moment from 'moment-timezone';
let promisesCache = {};

export default {
  data: () => ({
    inDelaySolicitationAllowed: false,
    hasAnticipationReadySolicitations: false,
    invalidateCache: false,
  }),

  methods: {
    async getAnticipationSolicitations(contracts = null) {
      try {
        if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
        if (!contracts) {
          const { LATE_SLIPS } = enums.financialModules;
          contracts = this.getAllowedContracts(
            LATE_SLIPS,
            this.selectedUnit.contracts
          );
        }

        const { sku } = this.selectedUnit;
        const params = {
          productSku: sku,
          contractIds: contracts.map((o) => o.id),
          contractTypes: contracts.map((o) => o.type),
          solicitationType: 'Anticipation',
        };

        const url = `${process.env.PAYMENT_SLIP_API_URL}/query`;

        // const paramsKey = JSON.stringify(params);
        // if (
        //   !promisesCache[paramsKey] ||
        //   moment().isAfter(promisesCache[paramsKey].validUntil) ||
        //   this.invalidateCache
        // ) {
        //   this.invalidateCache = false
        //   promisesCache[paramsKey] = {
        //     validUntil: moment()
        //       .add(5, 'minutes')
        //       .toISOString(),
        //     promise: this.requestService(url, 'GET', { params, localErrorHandling: true}).catch(err => {
        //       delete promisesCache[paramsKey];
        //       throw err;
        //     })
        //   };
        // }

        // const {
        //   items: solicitationsByContract,
        //   solicitationAllowed
        // } = await promisesCache[paramsKey].promise;

        const { items: solicitationsByContract, solicitationAllowed } =
          await this.requestService(url, 'GET', {
            params,
            localErrorHandling: true,
          });

        this.inDelaySolicitationAllowed = solicitationAllowed;

        if (solicitationsByContract) {
          const logSolicitations = [];

          //? interface ContractSolicitation {
          //?   contractId: number;
          //?   inProgress: boolean;
          //?   error: boolean;
          //?   ready: boolean;
          //?   systemDischarge: boolean;
          //?   items: SolicitationResultType[];
          //?   logGenerated: boolean;
          //?   logError: boolean;
          //?   logExpired: boolean;
          //? }

          //? interface SolicitationResultType {
          //?   contractId: number;
          //?   createdAt: Date | string;
          //?   parcels: any[];
          //?   expirationDate: Date | string;
          //?   documentCode: number;
          //?   slipUrl: string;
          //? }

          const readySolicitations = solicitationsByContract.reduce(
            (ready, contractSolicitations) => {
              if (contractSolicitations.ready) {
                const [item] = contractSolicitations.items; // SolicitationResultType
                ready.push(item);
              }
              if (
                contractSolicitations.logError ||
                contractSolicitations.logGenerated ||
                contractSolicitations.logExpired
              ) {
                logSolicitations.push(contractSolicitations);
              }
              return ready;
            },
            []
          );

          for (const logSolicitation of logSolicitations) {
            const slipContract = this.selectedUnit.contracts.find(
              (contract) => contract.id === logSolicitation.contractId
            );
            const solicitationDetails = logSolicitation.items[0];
            if (slipContract && solicitationDetails) {
              const {
                paymentTotal,
                solicitationCode,
                expirationDate,
                parcelIds,
                slipUrl,
              } = solicitationDetails;
              if (logSolicitation.logError || logSolicitation.logExpired) {
                const traceAction = logSolicitation.logError
                  ? enums.logTraceActions
                      .anticipationPaymentSlipSolicitationError
                  : enums.logTraceActions
                      .anticipationPaymentSlipSolicitationExpired;
                const traceInfo = {
                  contractId: slipContract.id,
                  contractType: slipContract.type,
                  detachedType: this.getContractTitle(slipContract),
                  paymentTotal,
                  solicitationCode,
                  expirationDate,
                  parcels: parcelIds,
                  slipUrl,
                };
                this.createTrace(traceAction, traceInfo);
              } else if (logSolicitation.logGenerated) {
                const traceInfo = {
                  contractId: slipContract.id,
                  contractType: slipContract.type,
                  detachedType: this.getContractTitle(slipContract),
                  paymentTotal,
                  solicitationCode,
                  expirationDate,
                  parcels: parcelIds,
                  slipUrl,
                };
                const traceAction =
                  enums.logTraceActions
                    .anticipationPaymentSlipSolicitationReady;
                this.createTrace(traceAction, traceInfo);
              }
            }
          }

          if (readySolicitations.length > 0) {
            this.$store.commit(
              NOTIFICATIONS.MUTATE_ANTICIPATION_PAYMENT_SLIPS,
              readySolicitations
            );
            this.hasAnticipationReadySolicitations = readySolicitations.some(
              (item) => item.solicitationType === SOLICITATE_TYPE.ANTICIPATION
            );
          }

          return solicitationsByContract;
        }
      } catch (err) {
        throw err;
      }
    },
    async sendSlipByEmailAnticipation(item, email, fromHome = false) {
      console.log('sendSlipByEmailAnticipation');

      const contractId = item.contractId;

      const data = {
        contractId,
        productCode: this.selectedUnit.product.code,
        blockCode: this.selectedUnit.block.code,
        unitCode: this.selectedUnit.unit.code,
        documentCode: item.documentCode,
        solicitationType: 'anticipation',
        userEmail: email,
      };

      const url = process.env.SLIP_CHECK_FUNCTION;
      const res = await requestService(`${url}/sendSlipEmail`, 'POST', {
        data,
        useLoading: false,
        localErrorHandling: true,
      });

      const { emailSended } = res;
      if (emailSended) {
        const slipContract = this.selectedUnit.contracts.find(
          (contract) => contract.id === contractId
        );
        const traceInfo = {
          contractId: contractId,
          contractType: slipContract.type,
          detachedType: this.getContractTitle(slipContract),
          expirationDate: item.expirationDate,
          serieId: item.serieId,
          serieCode: item.serieCode,
          parcelCode: item.parcelCode,
          discountedValue: item.discountedValue,
          ready: item.ready,
          url: item.slipUrl,
        };
        const { logTraceActions } = enums;
        const traceAction =
          logTraceActions[
            `anticipationPaymentSlipEmail${fromHome ? 'Home' : ''}`
          ];
        this.createTrace(traceAction, traceInfo);
      } else {
        console.error('Payment slip not ready');
      }
      return res;
    },
    async sendSlipBySmsAnticipation(item, cellphone, fromHome = false) {
      console.log('sendSlipBySmsAnticipation');

      const contractId = item.contractId;

      const data = {
        contractId,
        productId: this.selectedUnit.product.id,
        blockCode: this.selectedUnit.block.code,
        unitCode: this.selectedUnit.unit.code,
        documentCode: item.documentCode,
        smsType: 'anticipationSlipRequested',
        userPhoneNumber: cellphone,
      };

      const url = process.env.SMS_API;
      return requestService(`${url}/addToQueue`, 'POST', {
        data,
        useLoading: false,
        localErrorHandling: true,
      })
        .then((res) => {
          const { count } = res;
          if (count) {
            const slipContract = this.selectedUnit.contracts.find(
              (contract) => contract.id === contractId
            );
            const traceInfo = {
              contractId: contractId,
              contractType: slipContract.type,
              detachedType: this.getContractTitle(slipContract),
              expirationDate: item.expirationDate,
              serieId: item.serieId,
              serieCode: item.serieCode,
              parcelCode: item.parcelCode,
              discountedValue: item.discountedValue,
              ready: item.ready,
              url: item.slipUrl,
              barcode: item.barcode,
              userCellphone: cellphone,
            };
            const { logTraceActions } = enums;
            const traceAction =
              logTraceActions[
                `anticipationPaymentSlipSms${fromHome ? 'Home' : ''}`
              ];
            this.createTrace(traceAction, traceInfo);
          }
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/anticipationPaymentSlip.js